//@flow
import * as React from 'react';
import {
    Box,
    Text,
    Column,
    Columns,
    Button as NeoButton
} from '@locus-taxy/neo-ui';
import { Select } from 'common/components/core/select';
import { neoUIColors } from 'common/enums/ColorEnum';
import Statistic from 'common/components/core/stats/Statistic';
import NumberUtils from 'common/utils/NumberUtils';
import { type ThemeType } from 'react-css-themr';
import { Team } from 'common/models/internal/Team';
import { type TFunction } from 'react-i18next';
import type { TerritoryZoneType } from './TerritoryPlanningContainer';

export type TerritoryStatsType = {
    totalOutlets: number,
    totalDistributors: number,
    avgStoresPerTerritory: number,
    avgRevenuePerTerritory: number
};

export type TerritoryHomebaseType = {
    value: string,
    label: string
};
type Props = {
    latestMapId: string,
    t: TFunction,
    territoryStats: ?TerritoryStatsType,
    allOutletsCount: ?number,
    latestMapId: ?string,
    selectedZones: Array<TerritoryZoneType>,
    selectedTeam: ?Team,
    homebaseError: ?string,
    isHomebaseLoading: boolean,
    onHomebaseChange: () => void,
    getHomebaseList: () => Array<TerritoryHomebaseType>,
    theme: ThemeType,
    onSaveMapClick: () => void,
    viewLatestMap: () => void,
    selectedHomebase: ?{
        label: string,
        value: string
    }
};
export default class TerritoryPlanningHeader extends React.PureComponent<Props> {
    render() {
        const {
            latestMapId,
            theme,
            onSaveMapClick,
            viewLatestMap,
            selectedHomebase,
            selectedTeam,
            getHomebaseList,
            onHomebaseChange,
            isHomebaseLoading,
            selectedZones,
            homebaseError,
            territoryStats,
            allOutletsCount,
            t
        } = this.props;
        const avgStores = NumberUtils.formatNumber(
            territoryStats?.avgStoresPerTerritory,
            true,
            1
        );
        const avgRevenue = NumberUtils.formatNumber(
            territoryStats?.avgRevenuePerTerritory,
            true,
            1
        );
        return (
            <Box
                height="8vh"
                p={2}
                sx={{
                    border: `1px solid ${neoUIColors.grey200.code}`
                }}
            >
                <Columns alignY="center" space="medium">
                    <Column width="content">
                        <Text fontSize={4} fontWeight={600}>
                            {t('territory.territoryPlanner')}
                        </Text>
                    </Column>
                    <Column width="content">
                        <Text
                            fontSize={2}
                            fontWeight={600}
                            color={
                                selectedZones.length > 3
                                    ? neoUIColors.red500.code
                                    : neoUIColors.green500.code
                            }
                        >
                            {t('territory.selectedDist')}:{' '}
                            {selectedZones.length} / 5
                        </Text>
                    </Column>

                    <Column width="content">
                        <Statistic
                            disablePointerEvents
                            uppercase
                            value={territoryStats?.totalOutlets}
                            totalValue={allOutletsCount}
                            padLeft
                            title={t('territory.totalOutlets')}
                            theme={theme}
                        />
                    </Column>
                    <Column width="content">
                        <Statistic
                            disablePointerEvents
                            uppercase
                            value={territoryStats?.totalDistributors}
                            padLeft
                            title={t('territory.totalTerritories')}
                            theme={theme}
                        />
                    </Column>
                    <Column width="content">
                        <Statistic
                            disablePointerEvents
                            uppercase
                            value={avgStores}
                            padLeft
                            title={t('territory.avgStoresPerTerritory')}
                            theme={theme}
                        />
                    </Column>
                    <Column width="content">
                        <Statistic
                            disablePointerEvents
                            uppercase
                            value={avgRevenue}
                            padLeft
                            title={t('territory.avgRevenuePerTerritory')}
                            theme={theme}
                        />
                    </Column>
                    <Column width="content">
                        <Select
                            hasError={homebaseError}
                            error={homebaseError}
                            isLoading={isHomebaseLoading}
                            disabled={!selectedTeam}
                            options={getHomebaseList()}
                            value={selectedHomebase}
                            isClearable={false}
                            theme={theme}
                            onChange={onHomebaseChange}
                            selectLabel={t('territory.selectHomebase')}
                        />
                    </Column>

                    <Column width="fluid">
                        <Columns space="small" wrap align="right">
                            <NeoButton
                                disabled={!latestMapId}
                                palette="primary"
                                appearance="solid"
                                onClick={viewLatestMap}
                            >
                                {t('territory.viewRecentMap')}
                            </NeoButton>
                            <NeoButton
                                palette="primary"
                                appearance="solid"
                                onClick={onSaveMapClick}
                            >
                                {t('territory.saveMap')}
                            </NeoButton>
                        </Columns>
                    </Column>
                </Columns>
            </Box>
        );
    }
}
